'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactBootstrap = require('react-bootstrap');

var _reactRouterRedux = require('react-router-redux');

var _reactIntl = require('react-intl');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _components = require('../../components');

var _DefaultString = require('../../helpers/DefaultString');

var _Error = require('../../helpers/Error');

var _Password = require('../../helpers/Password');

var _PopupType = require('../../helpers/PopupType');

var _NeutralBrandingRoutes = require('../../helpers/NeutralBrandingRoutes');

var _Router = require('../../helpers/Router');

var _auth = require('../../redux/modules/auth');

var _popup = require('../../redux/modules/popup');

var _ResetPassword = require('./ResetPassword.scss');

var _ResetPassword2 = _interopRequireDefault(_ResetPassword);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ResetPassword = (_dec = (0, _reactRedux.connect)(function (state) {
  return { auth: state.auth };
}, { changePopupType: _popup.changePopupType, setPassword: _auth.setPassword, pushState: _reactRouterRedux.push }), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(ResetPassword, _Component);

  function ResetPassword() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ResetPassword);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ResetPassword.__proto__ || (0, _getPrototypeOf2.default)(ResetPassword)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      newPassword: '',
      confirmPassword: '',
      newPasswordError: false,
      confirmPasswordError: false
    }, _this.handleNewPasswordError = function (error) {
      _this.setState({ newPasswordError: error });
    }, _this.handleConfirmPasswordError = function (error) {
      _this.setState({ confirmPasswordError: error });
    }, _this.handleEnterKey = function (event) {
      if (event.key === 'Enter') {
        _this.submitNewPassword();
      }
    }, _this.handleConfirmPasswordChange = function (value) {
      _this.setState({ confirmPassword: value });
    }, _this.handleNewPasswordChange = function (value) {
      _this.setState({ newPassword: value });
    }, _this.handleConfirmPasswordBlur = function () {
      if (_this.state.confirmPassword && !(0, _Password.passwordMatch)(_this.state.newPassword, _this.state.confirmPassword)) {
        _this.handleConfirmPasswordError(true);
      }
    }, _this.handleNewPasswordBlur = function () {
      if (_this.state.newPassword && !(0, _Password.passwordValid)(_this.state.newPassword)) {
        _this.handleNewPasswordError(true);
      }
    }, _this.submitNewPassword = function () {
      if ((0, _Password.passwordValid)(_this.state.newPassword) && (0, _Password.passwordMatch)(_this.state.newPassword, _this.state.confirmPassword)) {
        var token = _this.context.router.location.query.token;
        _this.props.setPassword(_this.state.newPassword, token, _this.props.auth.lang);
      } else {
        _this.handleNewPasswordBlur();
        _this.handleConfirmPasswordBlur();
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ResetPassword, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.auth.setPassword && !nextProps.auth.setPassword) {
        if (!nextProps.auth.setPasswordError) {
          this.props.pushState((0, _Router.getPath)(_Router.RouterConst.ResetPasswordConfirmation));
        } else {
          var responseBody = nextProps.auth.setPasswordError.response.body;
          if (responseBody.code === _Error.ErrorConst.InvalidValue && responseBody.field === _Error.ErrorFieldConst.Token) {
            this.props.pushState((0, _Router.getPath)(_Router.RouterConst.ResetPasswordExpired));
          } else if (responseBody.code === _Error.ErrorConst.InvalidValue && responseBody.field === _Error.ErrorFieldConst.Password) {
            this.props.changePopupType(_PopupType.PopupId.InvalidResetPassword);
          }
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var isButtonInactive = this.state.newPasswordError || this.state.confirmPasswordError;
      var isNeutralRoute = (0, _NeutralBrandingRoutes.isNeutralBrandingRoute)(this.context.router.location.pathname);

      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(_ResetPassword2.default.resetPassword, { stingrayCorpo: isNeutralRoute }) },
        _react2.default.createElement(
          _components.DialogCard,
          {
            title: _react2.default.createElement(_reactIntl.FormattedMessage, _DefaultString.translations.PasswordResetTitle),
            message: _react2.default.createElement(_reactIntl.FormattedMessage, _DefaultString.translations.PasswordResetMessage)
          },
          _react2.default.createElement(
            _reactBootstrap.FormGroup,
            null,
            _react2.default.createElement(_components.PasswordInput, {
              password: this.state.newPassword,
              placeholder: _DefaultString.translations.NewPassword,
              handleEnterKey: this.handleEnterKey,
              intl: this.props.intl,
              handleErrorState: this.handleNewPasswordError,
              handleOnBlur: this.handleNewPasswordBlur,
              editPassword: this.handleNewPasswordChange,
              error: this.state.newPasswordError,
              errorString: _DefaultString.translations.PasswordMinError,
              name: 'password'
            }),
            _react2.default.createElement(_components.PasswordInput, {
              password: this.state.confirmPassword,
              placeholder: _DefaultString.translations.ConfirmNewPassword,
              handleEnterKey: this.handleEnterKey,
              intl: this.props.intl,
              handleErrorState: this.handleConfirmPasswordError,
              handleOnBlur: this.handleConfirmPasswordBlur,
              editPassword: this.handleConfirmPasswordChange,
              error: this.state.confirmPasswordError,
              errorString: _DefaultString.translations.PasswordMatchError,
              name: 'confirmPassword'
            }),
            _react2.default.createElement(
              'div',
              { className: _ResetPassword2.default.buttonContainer },
              _react2.default.createElement(_components.BaseButton, { onClick: this.submitNewPassword, buttonString: _DefaultString.translations.Submit, isInactive: isButtonInactive })
            )
          )
        ),
        _react2.default.createElement(_components.BrandLogos, null)
      );
    }
  }]);
  return ResetPassword;
}(_react.Component), _class2.propTypes = {
  changePopupType: _react.PropTypes.func,
  auth: _react.PropTypes.object,
  intl: _reactIntl.intlShape.isRequired,
  pushState: _react.PropTypes.func.isRequired,
  setPassword: _react.PropTypes.func
}, _class2.contextTypes = {
  router: _react2.default.PropTypes.object.isRequired,
  location: _react2.default.PropTypes.object
}, _temp2)) || _class);
exports.default = (0, _reactIntl.injectIntl)(ResetPassword);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/ResetPassword/ResetPassword.js
// module id = 2017
// module chunks = 0